import { purify } from "../../_src/components/purify";
import initSliderCourses from "../../_src/sections/slider/courses-home";

function checkOptionValue(select) {
  let value = ''
  document.querySelectorAll(select).forEach(function (el) {
    if(el.selected) {
      value = el.value
    }
  })
  return value
}

function loadMore(content) {
  const selectCurso = checkOptionValue("#select-curso option");
  const selectMunicipio = checkOptionValue("#select-municipio option");
  const selectPeriodo1 = document.querySelector("#select-periodo-1").value;
  const selectPeriodo2 = document.querySelector("#select-periodo-2").value;
  const loadMoreBtn = document.querySelector(`#loadMore-${content}`)
  let page = loadMoreBtn.dataset.page
  let activeFilter, URL;

  if (content == "formation") {
    activeFilter = document.querySelector(".slide-cursosETreinamentos-container button.active") ? document.querySelector(".slide-cursosETreinamentos-container button.active").dataset.content : ''
    URL = `/senar/cursos-e-treinamentos/ajax/cursos.html?content=${activeFilter}&curso=${selectCurso}&municipio=${selectMunicipio}&periodo1=${selectPeriodo1}&periodo2=${selectPeriodo2}&pagina=${page}`
  } else if (content == "promotion") {
    activeFilter = 'promocaoSocial'
    URL = `/senar/cursos-e-treinamentos/ajax/cursos.html?persona=${activeFilter}&curso=${selectCurso}&municipio=${selectMunicipio}&periodo1=${selectPeriodo1}&periodo2=${selectPeriodo2}&pagina=${page}`
  } else {
    URL = `/senar/cursos-e-treinamentos/ajax/cursos-ead.html/p${page}`
  }

  loadMoreBtn.classList.add("loading")

  fetch(URL)
      .then((response) => {
        return response.text();
      }).then((response) => {
        document.querySelector(`#result-${content}`).insertAdjacentHTML('beforeend',response)
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        let newPageNumber = parseInt(loadMoreBtn.dataset.page) + 1

        loadMoreBtn.dataset.page = newPageNumber

        if( parseInt(loadMoreBtn.getAttribute("data-page"))  > parseInt(loadMoreBtn.getAttribute("data-total")) ) {
          if (content == "ead") {
            loadMoreBtn.parentElement.style.display = "none"
          } else {
            loadMoreBtn.style.display = "none"
          }
        }

        loadMoreBtn.classList.remove("loading")
      });
}

const loadMoreFormation = document.querySelector("#loadMore-formation")
const loadMorePromotion = document.querySelector("#loadMore-promotion")
const loadMoreEAD = document.querySelector("#loadMore-ead")

loadMoreEAD?.addEventListener("click", function () {
  loadMore("ead")
})

loadMorePromotion?.addEventListener("click", function () {
  loadMore("promotion")
})

loadMoreFormation?.addEventListener("click", function () {
  loadMore("formation")
})

let totalPagesFormation = document?.querySelector("#total-pages")?.value
let totalPagesPromotion = document?.querySelector("#total-pagespromocaoSocial")?.value
let loadModeFormation = document.querySelector("#loadMore-formation")?.dataset.page
let loadModePromotion = document.querySelector("#loadMore-promotion")?.dataset.page

if (totalPagesFormation) {
  if (totalPagesFormation <= 1 && totalPagesFormation <= loadModeFormation) {
    document.querySelector("#loadMore-formation").classList.add("hidden")
  } else {
    document.querySelector("#loadMore-formation").dataset.total = totalPagesFormation
  }
}

if (totalPagesPromotion) {
  if (totalPagesPromotion <= 1 && totalPagesPromotion <= loadModePromotion) {
    document.querySelector("#loadMore-promotion").classList.add("hidden")
  } else {
    document.querySelector("#loadMore-promotion").dataset.total = totalPagesPromotion
  }
}

export function getCourses(id) {
  function search(content) {

    document.querySelectorAll(`#filter-${id} button`).forEach(function (el) {
      el.classList.add("disabled")
    })

    document.querySelector(`#result-${id}`).innerHTML = "";

    const selectCurso = checkOptionValue("#select-curso option");
    const selectMunicipio = checkOptionValue("#select-municipio option");
    const selectPeriodo1 = document.querySelector("#select-periodo-1").value;
    const selectPeriodo2 = document.querySelector("#select-periodo-2").value;

    fetch(`/senar/cursos-e-treinamentos/ajax/cursos.html/?content=${content}&curso=${selectCurso}&municipio=${selectMunicipio}&periodo1=${selectPeriodo1}&periodo2=${selectPeriodo2}&page=${1}`)
      .then((response) => {
        return response.text();
      }).then((response) => {
        document.querySelector(`#result-${id}`).innerHTML = purify(response);
      }).catch((error) => {
        console.error(error);
      }).finally(() => {      
        const loadMoreBtn = document.querySelector(`#loadMore-${id}`)
        let totalPages = document.querySelector("#total-pages").value
        loadMoreBtn.dataset.total = totalPages

        if (!document.querySelector(".loader-formation").classList.contains("hidden")) {
          document.querySelector(".loader-formation").classList.add("hidden")
        }

        initSliderCourses()

        document.querySelectorAll(`#filter-${id} button`).forEach(function (el) {
          el.classList.remove("disabled")
        })
           
        let totalPagesFormation = document?.querySelector("#total-pages")?.value
        let totalPagesPromotion = document?.querySelector("#total-pagespromocaoSocial")?.value
        let loadModeFormation = document.querySelector("#loadMore-formation").dataset.page
        let loadModePromotion = document.querySelector("#loadMore-promotion").dataset.page

        loadModeFormation = 2
        loadModePromotion = 2

        if (totalPagesFormation) {
          if (totalPagesFormation <= 1 && totalPagesFormation <= loadModeFormation) {
            document.querySelector("#loadMore-formation").classList.add("hidden")
          } else {
            document.querySelector("#loadMore-formation").dataset.page = 2
            document.querySelector("#loadMore-formation").classList.remove("hidden")
          }
        }

        if (totalPagesPromotion) {
          if (totalPagesPromotion <= 1 && totalPagesPromotion <= loadModePromotion) {
            document.querySelector("#loadMore-promotion").classList.add("hidden")
          } else {
            document.querySelector("#loadMore-promotion").dataset.page = 2
            document.querySelector("#loadMore-promotion").classList.remove("hidden")
          }
        }
      });
  }

  document.querySelectorAll(`[data-action=select-${id}]`).forEach(function (btn) {
    btn.addEventListener("click", function () {
      document.querySelector(".loader-formation").classList.remove("hidden")

      if (this.classList.contains("active")) {
        this.classList.remove("active")
        document.querySelectorAll(`[data-action=select-${id}]`).forEach(function (btn) {
          btn.classList.remove("active")
        })
        search('')
      } else {
        document.querySelectorAll(`[data-action=select-${id}]`).forEach(function (btn) {
          btn.classList.remove("active")
        })
        this.classList.add("active")
        search(this.dataset.content)
      }
    })
  })
}

if (document.querySelector("#result-formation") && document.querySelector("#result-promotion")) {
  getCourses("formation");
  getCourses("promotion");
}
